module.exports = __webpack_public_path__ + "static/media/hihocowboy.45e6d719.mp3";